import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Layout from './components/Layout';
// import Aos from 'aos';
// import 'aos/dist/aos.css';
// import { useEffect } from 'react';

function App() {
  // useEffect(() => {
  //   Aos.init({
  //     once: true,
  //   });

  //   // Refresh AOS to fix any visibility issues
  //   Aos.refresh();
  // }, []);
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
      </Route>
    </Routes>
  );
}

export default App;
